<template>
  <div class="vdatetime">
    <input class="vdatetime-input"
           :class="inputClass"
           type="text"
           :value="inputValue"
           :placeholder="placeholder"
           v-bind="$attrs"
           v-on="$listeners"
           @click="open($event,'click')">
           <!-- @focus="open($event,'focus')" -->
    <transition-group name="vdatetime-fade" tag="div" class="vdatetime-popup-nest">
      <div :key="'overlay'" v-if="isOpen" class="vdatetime-overlay" @click.self="cancel"></div>
      <datetimepopup :key="'popup'" v-if="isOpen"
          :type="type"
          :phrases="phrases"
          :use12-hour="use12Hour"
          :hour-step="hourStep"
          :minute-step="minuteStep"

          :datetime="popupDate"
          :min-datetime="popupMinDatetime"
          :max-datetime="popupMaxDatetime"

          @confirm="confirm"
          @cancel="cancel"
          :auto="auto"
          :week-start="weekStart"
          ></datetimepopup>
    </transition-group>
  </div>
</template>
<style>
.vdatetime .vdatetime-input{
    width: 92%;
    height: 100%;
    padding: 0 4%;
    margin: 0;
    position: relative;
    z-index: 1;
}
.vdatetime .vdatetime-fade-enter-active,
.vdatetime .vdatetime-fade-leave-active {
    transition: opacity .4s;
}
.vdatetime .vdatetime-fade-enter,
.vdatetime .vdatetime-fade-leave-to {
    opacity: 0;
}
.vdatetime .vdatetime-overlay {
    z-index: 999;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    transition: opacity .5s;
}
</style>
<script>
import { DateTime } from './luxon/src/luxon.js'
import DatetimePopup from './DatetimePopup.vue'
import { datetimeFromISO, startOfDay, weekStart } from './util.js'

export default {
  components: {
    "datetimepopup": DatetimePopup
  },

  props: {
    value: {
      type: String
    },
    valueZone: {
      type: String,
      default: 'UTC'
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    inputClass: {
      type: String,
      default: ''
    },
    zone: {
      type: String,
      default: 'local'
    },
    format: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: 'date'
    },
    phrases: {
      type: Object,
      default () {
        return {
          cancel: 'Cancel',
          ok: 'Ok'
        }
      }
    },
    use12Hour: {
      type: Boolean,
      default: false
    },
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    minDatetime: {
      type: String,
      default: null
    },
    maxDatetime: {
      type: String,
      default: null
    },
    auto: {
      type: Boolean,
      default: false
    },
    weekStart: {
      type: Number,
      default () {
        return weekStart()
      }
    }
  },

  data () {
    return {
      isOpen: false,
      // datetime: this.value ? datetimeFromISO(this.value).replace("中国标准时间 ","") : datetimeFromISO(this.value)
      datetime: datetimeFromISO(this.value)
    }
  },

  watch: {
    value (newValue) {
      // this.datetime = newValue ? datetimeFromISO(newValue).replace("中国标准时间 ","") : datetimeFromISO(newValue)
      this.datetime = datetimeFromISO(newValue)
    }
  },

  created () {
    this.emitInput()
  },

  computed: {
    inputValue () {
      const format = this.format || (this.type === 'date' ? DateTime.DATE_MED : DateTime.DATETIME_MED)

      // return this.datetime ? this.datetime.setZone(this.zone).toLocaleString(format) : ''
      let newTime = this.datetime ? this.datetime.setZone(this.zone).toLocaleString(format) : '';
      newTime = newTime ? newTime.replace("中国标准时间 ","").replace("中国标准时间","").replace("北美中部标准时间 ","").replace("北美中部标准时间","") : newTime;
      // if(this.type === 'date'){
      //   newTime = newTime ? newTime.split(" ")[0] : newTime;
      // }

      //部分浏览器不支持toLocaleString方法，会用toString方法替换，两种方法对标准时间格式的转换有区别
      //去除星期
      newTime = newTime.replace("Monday,","").replace("Tuesday,","").replace("Wednesday,","").replace("Thursday,","").replace("Friday,","").replace("Saturday,","").replace("Sunday,","");
      //月份转换中文
      newTime = newTime.replace("January ","1月").replace("February ","2月").replace("March ","3月").replace("April ","4月").replace("May ","5月").replace("June ","6月").replace("July ","7月");
      newTime = newTime.replace("January","1月").replace("February","2月").replace("March","3月").replace("April","4月").replace("May","5月").replace("June","6月").replace("July","7月");
      newTime = newTime.replace("Jan","1月").replace("Feb","2月").replace("Mar","3月").replace("Apr","4月").replace("May","5月").replace("Jun","6月").replace("Jul","7月");
      newTime = newTime.replace("August ","8月").replace("September ","9月").replace("October ","10月").replace("November ","11月").replace("December ","12月");
      newTime = newTime.replace("August","8月").replace("September","9月").replace("October","10月").replace("November","11月").replace("December","12月");
      newTime = newTime.replace("Aug","8月").replace("Sep","9月").replace("Oct","10月").replace("Nov","11月").replace("Dec","12月");
      //处理日期格式
      if(newTime.indexOf(",") >= 0){
        newTime = newTime.replace(" ","");
        let arrayTimes = newTime.split(",");
        let subNewTime = arrayTimes[0] + "日";
        if(arrayTimes.length > 1){
          subNewTime = arrayTimes[1] + "年" + subNewTime;
          subNewTime = subNewTime.replace(" ","");
        }
        if(arrayTimes.length > 2){
          if(arrayTimes[2].indexOf("AM") >= 0){
            subNewTime = subNewTime + " 上午" + arrayTimes[2].replace(" AM","").replace("AM","").replace(" ","");
          } else if(arrayTimes[2].indexOf("PM") >= 0){
            subNewTime = subNewTime + " 下午" + arrayTimes[2].replace(" PM","").replace("PM","").replace(" ","");
          }
        }
        newTime = subNewTime;
      }

      return newTime
    },
    popupDate () {
      return this.datetime ? this.datetime.setZone(this.zone) : DateTime.utc().setZone(this.zone)
    },
    popupMinDatetime () {
      return this.minDatetime ? DateTime.fromISO(this.minDatetime) : null
    },
    popupMaxDatetime () {
      return this.maxDatetime ? DateTime.fromISO(this.maxDatetime) : null
    }
  },

  methods: {
    emitInput () {
      let datetime = this.datetime ? this.datetime.setZone(this.valueZone) : null;

      if (datetime && this.type === 'date') {
        datetime = startOfDay(this.datetime)
      }

      this.$emit('input', datetime ? datetime.toISO() : '');
    },
    open ($event,eventType) {
      // alert(DateTime.utc().toString());
      $event.target.blur();
      let isEffective = this.checkBrowser();
      if(!isEffective && eventType == "focus"){
        alert("很抱歉，您当前使用的浏览器不支持该功能！请尝试用微信或其他浏览器打开。");
        return false;
      }

      this.isOpen = true;
      this.$emit("openCalendar");
    },
    close () {
      this.isOpen = false;
      this.$emit("closeCalendar");
    },
    confirm (datetime) {
      this.datetime = datetime.toUTC();
      this.emitInput()
      this.close()
    },
    cancel () {
      this.close()
    },
    //判断浏览器
    checkBrowser(){
        let isEffective = true;
        let myBrowser = "";
        let userAgent = navigator.userAgent;
        if (userAgent.indexOf("MZBrowser") > -1) { //判断是否MeiZu浏览器
            myBrowser = "MZBrowser";
            isEffective = false;
        }
        return isEffective;
        // alert(userAgent);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/shared/libs/vue-datetime/Datetime.vue